import React, { FC, Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Chip } from '@mui/material';
import RequestConnectionDialog from 'components/clinic-requests/request-connection-dialog.component';
import { DirectoryLab } from 'components/supplier-browser/directory-browser-config';
import { SupplierConnectionState } from 'models/supplier-request';

/**
 * DD-3696: the lab's state for this clinic. DD-3702: a clinic no longer connects at once —
 * it asks, and the lab approves first: "Connected", "Request sent", or "Request".
 */
const ConnectLabAction: FC<{ lab: DirectoryLab }> = ({ lab }) => {
    const { t: translate } = useTranslation(['client-directory']);
    const [isRequestOpen, setIsRequestOpen] = useState(false);

    if (lab.connection === SupplierConnectionState.CONNECTED) {
        return <Chip size="small" color="success" label={translate('client-directory:SUPPLIER_CONNECTED')} />;
    }
    if (lab.connection === SupplierConnectionState.PENDING) {
        return <Chip size="small" color="warning" label={translate('client-directory:SUPPLIER_REQUEST_PENDING')} />;
    }
    return (
        <Fragment>
            <Button
                variant="contained"
                size="small"
                onClick={() => setIsRequestOpen(true)}
                data-test={`lab-browser.request-${lab._id}`}
            >
                {translate('client-directory:REQUEST_SUPPLIER')}
            </Button>
            <RequestConnectionDialog
                target={isRequestOpen ? { organizationId: lab._id, name: lab.name, kind: 'LAB' } : undefined}
                onClose={() => setIsRequestOpen(false)}
            />
        </Fragment>
    );
};

export default ConnectLabAction;
